// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Window_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5Zm0 1.5v3H3.75v-3Zm0 13.5H3.75v-9h16.5v9Z',
  viewBox: '0 0 24 24',
  glyph: 'Window_Stroke2_Corner2_Rounded',
})
